import type { ThemeConfig } from 'antd'

import { BORDER, BUTTON_BG, BUTTON_HOVER_BG, SURFACE, TEXT } from './colors'

export const CLIENT_PAGE_THEME: ThemeConfig = {
  components: {
    Button: {
      borderRadius: 6,
      borderRadiusLG: 6,
      borderRadiusSM: 4,
      colorPrimary: TEXT,
      colorPrimaryActive: '#000000',
      colorPrimaryHover: '#333333',
      dangerShadow: 'none',
      defaultActiveBg: BUTTON_HOVER_BG,
      defaultActiveBorderColor: 'transparent',
      defaultActiveColor: TEXT,
      defaultBg: BUTTON_BG,
      defaultBorderColor: 'transparent',
      defaultColor: TEXT,
      defaultHoverBg: BUTTON_HOVER_BG,
      defaultHoverBorderColor: 'transparent',
      defaultHoverColor: TEXT,
      defaultShadow: 'none',
      fontWeight: 600,
      primaryShadow: 'none',
    },
    Card: {
      borderRadiusLG: 8,
      bodyPadding: 24,
      colorBorderSecondary: BORDER,
      fontWeightStrong: 700,
      headerFontSize: 18,
      headerPadding: 24,
    },
  },
}

// The app theme turns on wireframe, and Pagination reads wireframe from the global token only.
export const TABLE_PAGINATION_THEME: ThemeConfig = {
  token: { wireframe: false },
  components: {
    Pagination: {
      borderRadius: 6,
      colorBgTextActive: BUTTON_HOVER_BG,
      colorBgTextHover: BUTTON_BG,
      colorPrimary: TEXT,
      colorPrimaryHover: TEXT,
      fontWeightStrong: 600,
      itemActiveBg: TEXT,
      itemActiveColor: SURFACE,
      itemActiveColorHover: SURFACE,
      itemBg: 'transparent',
      itemLinkBg: 'transparent',
    },
  },
}
